// extracted by mini-css-extract-plugin
export default {"CollapseButton":"CollapseButton_CollapseButton__65q3t"};